<template>
	<nk-page commercialAccess="Sale" :buttons="[buttons_access_management]" :policyClaims="['SaleBuy_FactorBunch_Management']">
		<template #badges>
			<nk-badge system="sale"></nk-badge>
		</template>

		<nk-table v-model="selectedRow" @data-changed="dataChanged" :data="factorBunches" :options="tableOptions" ref="table" tabindex="101" startup @row_dbClicked="rowDbClicked" class="nk-card">
		</nk-table>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import Input from '~/components/general/nikan-input.vue'
	import $sc from '~/plugins/shortcut.collection'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import validators from '~/statics/validators'
	import { post } from '~/plugins/nikan-api'
	import Dropdown from '~/components/general/dropdown.vue'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'
	import Switch from '~/components/general/nikan-switch.vue'
	import BooleanView from '~/components/form/boolean-label'
	import AccessControl from '~/views/operation-roles/access-control'
	import { mapGetters, mapActions } from 'vuex'

	export default {
		modal: {
			size: 'md',
			stateUID: 'factor-Bunch',
			helpTag: 'FactorBunch'
		},
		props: {
			data: { type: Object },
			options: { type: Object, defualt: () => { } },
		},
		data() {
			return {
				localSelectedItem: null,
				settings: {
					selectable: false
				},
				pageButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						icon: 'save',
						visible: true,
						disabled: true,
						handle: (button, page, e) => {
							this.save().then((res) => {
								this.$nikan.formUtility.switchMode(this.pageButtons, 'select')
								this.$refs.table.table_Focused()
							})
						},
						policyClaims: 'SaleBuy_FactorBunch_Edit',
					},
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('save'),
						element: () => this.$refs.table.$el,
						icon: 'check',
						visible: true,
						disabled: false,
						isPrimary: true,
						handle: (button, page, e) => {
							if (_.isEmpty(this.selectedRow))
								return this.$toast(this.$t('document.m.select-row'))

							this.resolve(this.selectedRow)
						},
						policyClaims: 'SaleBuy_FactorBunch_Select',
					},
				},
				buttons_access_management: {
					title: this.$t('operationRole.claims'),
					policyClaims: 'General_Access_Management',
					handle: (button, page, e) => {
						let selectedRow = _.head(this.$refs['table'].localValue)
						this.showModal({
							component: AccessControl,
							data: {
								prefix: 'SaleBuy_FactorBunch',
								accessData: selectedRow && selectedRow.id && selectedRow.id != emptyId
									? {
										entityId: selectedRow.id,
										entityType: 'FactorBunch',
										objectDescription: `${selectedRow.name}`,
									}
									: null,
							},
						})
							.then((node) => { })
							.catch(() => { })
					},
					icon: 'user-lock',
				},
				selectedRow: null,
				factorTypes: [],
				tableOptions: {
					activeRowDisabled: true,
					editable: this.$nikan.checkPermission('SaleBuy_FactorBunch_Edit'),
					searchable: false,
					allowNewRow: true,
					displayOrderEnabled: false,
					alwaysEmit: true,
					buttons: {
						addBtn: {
							options: {
								visible: true,
								policyClaims: 'SaleBuy_FactorBunch_Edit',
							}
						},
						deleteBtn: {
							options: {
								visible: true,
								policyClaims: 'SaleBuy_FactorBunch_Edit',
							}
						}
					},
					prepareNewRow: () => {
						return {
							fiscalPeriodId: emptyId,
							code: '',
							name: '',
							firstSerialNumber: 0,
							lastSerialNumber: 0,
							isActive: true,
							ignoreTax: false,
						}
					},
					columns: [
						{
							name: 'rowNumber',
							title: this.$t('row-number'),
							searchable: true,
							sortable: true,
							editable: false,
							entering: false,
							pinned: true,
							pinnable: false,
							resizable: false,
							width: '10%',
						},
						{
							name: 'code',
							title: this.$t('sale.factor_bunches.f.code'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '10%',
						},
						{
							name: 'factorType',
							title: this.$t('sale.factor_bunches.f.factorType'),
							width: '20%',
							editable: true,
							view: {
								options: {
									format: (item) => {
										return this.$t('sale.factor.types.' + item.toLowerCase())
									},
								},
							},
							edit: (row, col) => {
								return {
									component: Dropdown,
									options: {
										selectorWidth: '200px',
										remoteSearch: false,
										placeholder: this.$t('select-it'),
										getDataFromOptions: true,
										locateSelectorBasedOnDocument: true,
										searchPrefix: 'sale.factor.types',
										display: (item) => {
											return this.$t('sale.factor.types.' + item.toLowerCase())
										},
										data: this.factorTypes.map((x) => x.key),
									},
								}
							},
							entering: true,
							validators: validators('required'),
						},
						{
							name: 'name',
							title: this.$t('sale.factor_bunches.f.name'),
							edit: {
								component: Input,
								options: {
									mode: 'string',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '20%',
						},
						{
							name: 'firstSerialNumber',
							title: this.$t('sale.factor_bunches.f.firstSerialNumber'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '20%',
						},
						{
							name: 'lastSerialNumber',
							title: this.$t('sale.factor_bunches.f.lastSerialNumber'),
							edit: {
								component: Input,
								options: {
									mode: 'integer',
								},
							},
							searchable: true,
							sortable: false,
							editable: true,
							validators: validators('required'),
							width: '20%',
						},
						{
							name: 'isActive',
							title: this.$t('sale.factor_bunches.f.isActive'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-active-deactive',
								useTranslate: true,
							},
							view: {
								component: BooleanView,
								options: {
									useColors: true,
								},
							},
							edit: {
								component: Switch,
								options: {
									mode: 'number',
								},
							},
							editable: true,
							entering: true,
							validators: validators('required'),
							width: '10%',
						},
						{
							name: 'ignoreTax',
							title: this.$t('sale.factor_bunches.f.ignoreTax'),
							type: 'dropdown',
							search: {
								prefix: 'boolean-active-deactive',
								useTranslate: true,
							},
							view: {
								component: BooleanView,
								options: {
									useColors: true,
								},
							},
							edit: {
								component: Switch,
								options: {
									mode: 'number',
								},
							},
							editable: true,
							entering: true,
							width: '10%',
						},
					],
				},
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},
		created() {
			this.localSelectedItem = this.data
		},
		computed: {
			...mapGetters({
				all: 'factorBunches/all'
			}),
			factorBunches() {
				if (this.settings.factorType)
					return this.all.filter(factor => factor.factorType === this.settings.factorType)
				return this.all
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.pageButtons.selectButton.visible = this.settings.selectable

			let buttonsArray = [
				this.pageButtons.selectButton,
				this.pageButtons.saveButton,
			]

			this.prepareWindow(this.$t('sale.factor_bunches.title'), buttonsArray)
			this.refreshFactorBunches()
			this.getProperties()
		},
		methods: {
			...mapActions({
				broadcastRefresh: 'socket/broadcastRefresh',
				refreshFactorBunches: 'factorBunches/refresh'
			}),
			dataChanged() {
				this.$nikan.formUtility.switchMode(this.pageButtons, 'edit')
			},
			save() {
				var that = this

				return new Promise((resolve, reject) => {
					this.$refs.table
						.commitChanges()
						.then((factorBunches) => {
							var data = {
								Items: factorBunches,
							}
							var wait = this.$wait(this.$refs.table.$el)
							post(Endpoints.getUrl('sale.factor.bunch.modify'), data)
								.then((result) => {
									wait.end()
									this.$toast(this.$t('sale.factor_bunches.save.success'), { type: 'success' })
									resolve(that.factorBunches)
									this.broadcastRefresh('FactorBunches')
								})
								.catch(() => {
									wait.end()
									that.defer(() => that.$refs.table.$el.focus(), 1)
								})
						})
						.catch((errorRows) => {
							if (Array.isArray(errorRows)) {
								var rowNumbers = errorRows.map((x, i) => x.rowNumber).join(',')
								console.log(errorRows)
								dialog({
									title: this.$t('sale.factor_bunches.m.save-title'),
									body: this.$t('sale.factor_bunches.save.error.rows', {
										rowNumbers,
									}),
									type: 'error',
								})
							} else {
								dialog({
									title: this.$t('sale.factor_bunches.m.save-title'),
									body: errorRows.message,
									type: 'error',
								})
							}

							reject(new Error('invalid-rows'))
							that.defer(() => that.$refs.table.$el.focus(), 100)
						})
				})
			},
			getProperties() {
				this.factorTypes = this.getPropertiesByGroup('FactorTypes')
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			}
		},
	}
</script>
<style></style>
